import { render, staticRenderFns } from "./#mail-list.vue?vue&type=template&id=3bee914e&scoped=true&"
import script from "./#mail-list.vue?vue&type=script&lang=js&"
export * from "./#mail-list.vue?vue&type=script&lang=js&"
import style0 from "./#mail-list.vue?vue&type=style&index=0&id=3bee914e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bee914e",
  null
  
)

export default component.exports